import { HttpContextToken } from '@angular/common/http';

/**
 * Marks a request as part of the session-bootstrap flow (POST /api/v1/sessions
 * with `Authorization: Bearer <plg_token>`). When set, the 401 interceptor must
 * not try to recover by re-bootstrapping — that would loop.
 */
export const SKIP_AUTH_RETRY = new HttpContextToken<boolean>(() => false);
